export const LIGHTBOX_OPEN = 'LIGHTBOX_OPEN'
export const LIGHTBOX_CLOSE = 'LIGHTBOX_CLOSE'

const open = (photoSrc = '') => ({
  type: LIGHTBOX_OPEN,
  photoSrc,
  isLightboxOpen: true,
})

const close = () => ({
  type: LIGHTBOX_CLOSE,
  isLightboxOpen: false,
})

export const openLightbox =
  (src = '') =>
  (dispatch) =>
    dispatch(open(src))

export const closeLightbox = () => (dispatch) => dispatch(close())
